import React from "react";
import {
  Shield,
  BookOpen,
  Award,
  MapPin,
  MessageSquare,
  Briefcase,
} from "lucide-react";

const items = [
  {
    Icon: Shield,
    title: "15+ years as a bailiff",
    body: "I understand how court orders are enforced in real life — not just on paper.",
  },
  {
    Icon: BookOpen,
    title: "LLB (Honours) Law",
    body: "Up-to-date legal knowledge supported by practical experience and continued professional development.",
  },
  {
    Icon: Award,
    title: "Fully trained McKenzie Friend",
    body: "Completed specialist training to support litigants in person at hearings.",
  },
  {
    Icon: MapPin,
    title: "Local to Mansfield",
    body: "Familiar with the local family courts across Nottinghamshire, Derbyshire & Sheffield.",
  },
  {
    Icon: MessageSquare,
    title: "Clear, jargon-free advice",
    body: "Plain English. Honest answers. No hidden costs or empty reassurances.",
  },
  {
    Icon: Briefcase,
    title: "Documents & attendance",
    body: "Full support — from court bundle preparation through to hearing day.",
  },
];

const WhyChooseMe = () => {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative py-24 md:py-32 bg-[#262321] hairline-t hairline-b overflow-hidden"
    >
      <div className="absolute inset-0 grain-overlay" aria-hidden="true" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 mb-14">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#C89D54]" />
              <span className="overline">Why Choose Me</span>
            </div>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-[#F4F0EB] tracking-tight leading-[1.05]">
              Real courtroom experience
              <span className="block italic text-[#C89D54]">
                meets legal study.
              </span>
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-6">
            <p className="font-sans-body text-base md:text-lg text-[#A6A098] leading-relaxed">
              Few McKenzie Friends combine 15 years of practical enforcement
              experience with active legal study. The result is straightforward,
              grounded support for the people who need it most — at one of the
              hardest moments of their lives.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#C89D54]/15">
          {items.map(({ Icon, title, body }, i) => (
            <div
              key={title}
              data-testid={`why-card-${i}`}
              className="group bg-[#262321] p-8 md:p-10 hover:bg-[#2E2A28] transition-colors duration-500"
            >
              <div className="h-12 w-12 flex items-center justify-center border border-[#C89D54]/40 mb-6 group-hover:border-[#C89D54] group-hover:bg-[#C89D54]/5 transition-all">
                <Icon size={20} className="text-[#C89D54]" strokeWidth={1.8} />
              </div>
              <h3 className="font-serif-display text-2xl text-[#F4F0EB] leading-tight">
                {title}
              </h3>
              <p className="mt-3 text-sm font-sans-body text-[#A6A098] leading-relaxed">
                {body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseMe;
